import { render, staticRenderFns } from "./GuppyChatGroupList.vue?vue&type=template&id=4ebbf0a1&"
import script from "./GuppyChatGroupList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports